<template>
  <div class="cilinder-row" :class="{'selected': active}">
    <div class="selection">
      <label for="selectCilinder"></label>
      <input type="checkbox" :checked="active" id="selectCilinder" name="selectCilinder"
             @click="selectCilinder">
    </div>
    <div class="piston_al" v-text="cilinder.piston_al"></div>
    <div class="rod_s" v-text="cilinder.rod_s"></div>
    <div class="stroke_k" v-text="cilinder.stroke_k"></div>
    <div class="attachment">
      <img class="cilinder-render" :src="cilinderPushImage" alt="">

      <button @click="openShare(cilinder.id)" class="download-link">
        <img :src="getImage('3dstepicon.png')" alt="">
      </button>

    </div>
    <div class="supply">
      <img
          :src="getImage('check-motor.svg')"
          :id="'supply' + cilinder.id"
          @mouseenter="hover = true"
          @mouseleave="hover = true"
          v-if="cilinder.stock >= this.ownValue"
      >
      <img
          :src="getImage('warning.svg')"
          :id="'supply' + cilinder.id"
          @mouseenter="hover = true"
          @mouseleave="hover = true"
          v-else
      >

      <b-tooltip :show.sync="hover" :target="'supply' + cilinder.id" placement="top" variant="info" boundary="window">
        <div v-if="cilinder.stock <= 0">
          {{ cilinder.delivery_time }}
        </div>
        <div v-else-if="cilinder.stock >= this.ownValue">
          {{ cilinder.delivery_message }}
        </div>
        <table class="table table-borderless" style="color: white;" v-else>
          <tr>
            <th width="100" class="text-left">{{ cilinder.stock }} cilinders</th>
            <td class="text-left">{{ cilinder.delivery_message }}</td>
          </tr>
          <tr>
            <th width="100" class="text-left">{{ this.ownValue - cilinder.stock }}
              cilinder{{ (this.ownValue - cilinder.stock) > 1 ? 's' : '' }}
            </th>
            <td class="text-left">{{ $t('cylinder.list.expectedDeliveryTime') }} {{ cilinder.delivery_time }}</td>
          </tr>
        </table>
      </b-tooltip>
    </div>

    <div class="price">&euro; {{ (cilinder.price / 100).toFixed(2).replace('.', ',') }}</div>
    <div class="amount-table">
      <span class="subtract" @click="changeVal('decrement')">&#8722;</span>
      <input class="amount" type="number" v-model="ownValue" @change="input" min="1">
      <span class="add" @click="changeVal('increment')">&#43;</span>
    </div>
    <div class="actions">
      <button type="button" class="btn btn-success add-to-cart" @click="addToCart(cilinder); animate($event)">
        <img src="../../assets/cart-icon.png" alt="">{{ $t('cylinder.list.add') }}
      </button>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex';
import Checkbox from "@/components/input/Checkbox";

import { getFromStorage } from "@/helpers/backendStorage";
import { getStepUrl } from "@/mixins/downloadStepMixin";
import { redirectToLoginModal } from "@/mixins/swalMixin";

export default {
  name: "Cilinder",
  components: {Checkbox},
  props: {
    cilinder: {
      type: Object,
      default: {},
    },
  },

  data() {
    return {
      ownValue: 1,
      hover: false,
    }
  },

  computed: {
    ...mapState({
      magentoLoggedIn: state => state.preference.magentoLoggedIn,
      selectedCilinder: state => state.preference.selectedCilinder,
    }),
    ...mapGetters({
      cilinderOptions: 'preference/getCilinderOptions',
      attachmentsById: 'cilinders/getAttachmentsById',
      cilinderCircuit: 'preference/getCilinderCircuit',
      isMagento: 'preference/isMagento',
      isLoggedIn: 'auth/isLoggedIn',
    }),
    active() {
      return this.selectedCilinder === this.cilinder.id;
    },
    cilinderPushImage() {
      const image = this.cilinder.type === 'single' ? 'image_single_push' : 'image_push';

      return getFromStorage(this.cilinder.attachment[image]);
    },
  },

  methods: {
    getStepUrl,
    redirectToLoginModal,
    getFromStorage,
    ...mapActions({
      redirectToLoginUrl: 'auth/redirectToLoginUrl',
    }),
    openShare(cilinderId) {
      this.$store.dispatch('share/open', {
        configurator: 'cylinder',
        uid: '' + cilinderId,
        trigger: 'download-step',
      });
    },
    getIcon() {
      return this.active ? require('../../assets/check-motor-white.svg') : require('../../assets/check-motor.svg')
    },
    async selectCilinder() {
      if (!this.active) {
        await this.$store.dispatch('preference/selectCilinder', this.cilinder.id);

        let {rod_s, piston_al, stroke_k} = this.cilinder;
        this.$store.commit('preference/setCilinderStroke', stroke_k);
        this.$store.commit('preference/setCilinderPistonDiameter', piston_al);
        this.$store.commit('preference/setCilinderRodDiameter', rod_s);
      } else {
        this.$store.commit('preference/resetCilinderSelection');
      }

      this.scrollToTargetAdjusted();
    },
    scrollToTargetAdjusted() {
      let element = document.getElementsByClassName('cilinder-row selected')[0];
      if (element) {
        element.scrollIntoView({behavior: 'instant', block: 'center', inline: 'center'});
      }
    },
    animate(elem) {
      let tr = elem.target.closest('.cilinder-row');
      if (!tr.classList.contains('fly')) {
        tr.classList.add('fly')
      }

      setTimeout(() => {
        tr.classList.remove('fly');
      }, 1000)
    },
    addToCart(cylinder) {
      if (this.isMagento) {
        this.$emit('openModal');
        cylinder.amount = this.ownValue;
        const data = {
          products: {
            [cylinder.article_number]: cylinder.amount
          },
          build_id: null,
          build_type: null,
        };
        this.$store.dispatch('cart/sendToMagentoCart', {data, build: cylinder}).then((order) => {
          order.name = this.translate(order.name);
          this.$store.commit('cart/setCurrentOrder', order);
        }).catch((error) => {
          this.$store.commit('cart/setCurrentOrder', {error: error});
        });
      } else {
        const {id, article_number} = cylinder;
        this.$store.commit('cart/cilinderItems/setCartItems', {product: id, article_number, amount: this.ownValue});
        this.$store.dispatch('cart/setCartLocalStorage');
      }
    },
    changeVal(type) {
      if (type === 'decrement' && this.ownValue !== 1) {
        this.ownValue--;
      } else if (type === 'increment') {
        this.ownValue++;
      }
    },
    input(e) {
      let value = e.target.value;
      if (isNaN(e.target.value)) {
        value = 0;
      }
      this.ownValue = value;
      this.$emit('input', value);
      this.$emit('change', value);
    },
  },
}
</script>

<style lang="scss">

.fly {
  animation: fly-to-cart 0.85s;
}

.tooltip-inner {
  max-width: 350px;
}

@keyframes fly-to-cart {
  from {
    transition: opacity ease 0.3s;
    background-color: #71BC2D;
  }
  to {
    transition: opacity ease 0.3s;
  }
}

.cilinder {
  display: block;
  position: relative;
  margin: 0;
  transition: all ease 0.3s;
  cursor: pointer;

  &:not(.active):hover {
    .icon {
      margin-right: 15px;
    }
  }

  &:before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    top: 0;
    width: 0;
    transition: all ease 0.3s;
    z-index: 0;
  }

  .icon {
    width: 13px;
    height: 13px;
    margin-right: 10px;
    margin-bottom: 6px;
    transition: all ease 0.3s;
    position: relative;
    z-index: 1;
  }

  .power {
    display: inline-block;
    font-size: 14px;
    font-family: neue-haas-grotesk-text, sans-serif;
    font-weight: 400;
    color: #D7D7D7;
    margin-right: 10px;
    transition: all ease 0.3s;
    position: relative;
    z-index: 1;
  }

  .kwh {
    font-family: neue-haas-grotesk-display, sans-serif;
    color: #D7D7D7;
    transition: all ease 0.3s;
    position: relative;
    z-index: 1;
    font-size: 12px;
  }

  &:after {
    content: '';
    position: absolute;
    right: 15px;
    top: 0;
    bottom: 0;
    width: 8px;
    background: url(../../assets/arrow-right.svg) no-repeat center;
    background-size: 5px 8px;
    opacity: 0;
    transition: all ease 0.3s;
    z-index: 1;
  }

  &.available {

    .power {
      color: black;
    }

    .kwh {
      color: black;
    }

    &:after {
      opacity: 1;
    }
  }

  &.active {
    letter-spacing: 1px;

    &:before {
      width: 100%;
      background-color: #3DB0C7;
    }

    .power {
      color: #fff;
    }

    .kwh {
      color: #fff;
      font-weight: unset;
    }

    &:after {
      filter: brightness(4);
    }
  }
}

.selection {
  position: relative;

  input[type=checkbox] {
    position: relative;
    top: 0;
    left: 0;
    cursor: pointer;
  }

  input[type=checkbox]:before {
    content: "";
    display: block;
    position: absolute;
    width: 20px;
    height: 20px;
    top: -3px;
    left: -4px;
    background-color: lighten(#3db0c7, 30%);
  }

  input[type=checkbox]:checked:before {
    content: "";
    display: block;
    position: absolute;
    width: 20px;
    height: 20px;
    top: 0;
    left: 0;
    background-color: #3db0c7;
  }

  input[type=checkbox]:checked:after {
    content: "";
    display: block;
    width: 6px;
    height: 12px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    position: absolute;
    top: 2px;
    left: 7px;
  }
}

input.amount {
  width: 50px;
  border: 0;
  margin: 0 2px;
}

.supply {
  img {
    width: 20px;
    height: 20px;
    cursor: pointer;
    transition: all ease 0.3s;

    &:hover {
      transform: scale(1.2);
    }
  }
}

.popup {
  position: relative;

  .backdrop {
    background-color: rgba(0, 0, 0, .5);
    position: fixed;
    z-index: 3;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  }

  .content {
    box-sizing: border-box;
    padding: 20px 15px;
    background: #fff;
    position: absolute;
    top: -45px;
    left: 12px;
    width: 100vw;
    max-width: 300px;
    min-height: 80px;
    z-index: 99999;
    box-shadow: -2px 0 15px rgba(0, 0, 0, .1);

    &:after {
      content: "";
      display: block;
      height: 10px;
      width: 10px;
      background: inherit;
      position: absolute;
      top: 40px;
      left: 0;
      transform: translateX(-50%) rotate(45deg);
    }

    .text {
      padding: 10px 0;
      display: block;
    }

    .close {
      width: 10px;
      height: 10px;
      position: relative;
      float: right;
      margin-top: -4px;
      cursor: pointer;

      &:before, &:after {
        content: "";
        display: block;
        height: 2px;
        width: 18px;
        background: #a4afb7;
        position: absolute;
        top: 50%;
        left: 50%;
      }

      &:before {
        transform: translateX(-50%) translateY(-50%) rotate(45deg);
      }

      &:after {
        transform: translateX(-50%) translateY(-50%) rotate(-45deg);
      }
    }
  }
}

</style>
